import { safeProp } from '@lc/libutils'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type Asset = {
	url: string
	source: 'default' | 'valkyrie'
}
export type AssetsSlice = Record<string, Asset>
export const defaultAssetsSlice: AssetsSlice = {}

export const assetsSlice = createSlice({
	name: 'assets',
	initialState: defaultAssetsSlice,
	reducers: {
		setAssets: (_state, action: PayloadAction<AssetsSlice>) => {
			return action.payload
		},
		setDefaultAsset: (state, action: PayloadAction<[string, string]>) => {
			const [id, path] = action.payload
			if (state[safeProp(id)]?.source !== 'valkyrie') {
				state[safeProp(id)] = { url: path, source: 'default' }
			}
		},
		setDefaultAssets: (
			state,
			action: PayloadAction<Record<string, string>>,
		) => {
			for (const [id, path] of Object.entries(action.payload)) {
				if (state[safeProp(id)]?.source !== 'valkyrie') {
					state[safeProp(id)] = { url: path, source: 'default' }
				}
			}
		},
	},
	selectors: {
		getAsset: (state, id: string): Asset | undefined => state[safeProp(id)],
		getAssetUrl: (state, id: string): string | undefined => {
			const asset: Asset | undefined = state[safeProp(id)]
			return asset?.url
		},
		listAssets: state => Object.keys(state),
	},
})

export const {
	reducer: assetsReducer,
	actions: { setAssets, setDefaultAsset, setDefaultAssets },
	selectors: { getAsset, getAssetUrl, listAssets },
} = assetsSlice
